import { gql } from '@apollo/client'

export const GET_DATA_SOURCE_CHOOSEN = gql`
  mutation GetDataSourceOfFormFieldTypeChoosenSource(
    $idFormFieldTypeChoosenSource: Int!
  ) {
    getDataSourceOfFormFieldTypeChoosenSource(
      idFormFieldTypeChoosenSource: $idFormFieldTypeChoosenSource
    ) {
      value
      label
    }
  }
`

export const GET_ALL_CHOSSEN_SOURCE_BY_TYPE = gql`
  mutation GetAllFormFieldTypeChoosenSourceByType($type: String!) {
    getAllFormFieldTypeChoosenSourceByType(type: $type) {
      id
      description
      source_table
      key
      label
      source_json
    }
  }
`
